// Format Date to YYYY-MM-DD string
export const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Parse YYYY-MM-DD string to Date in local timezone
// This avoids the timezone issue where "2024-01-14" becomes Jan 13 in local time
export const parseDateStr = (dateStr: string): Date | null => {
  if (!dateStr) return null;

  const parts = dateStr.split("-");
  if (parts.length !== 3) return null;

  const [year, month, day] = parts.map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;

  // Create date in local timezone, not UTC
  return new Date(year, month - 1, day);
};

// Check if dates are the same day (ignoring time)
export const isSameDay = (date1: Date, date2: Date): boolean => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

// Check if a date is between two other dates (exclusive)
export const isDateBetween = (date: Date, start: Date, end: Date): boolean => {
  const dateTime = new Date(date).setHours(0, 0, 0, 0);
  const startTime = new Date(start).setHours(0, 0, 0, 0);
  const endTime = new Date(end).setHours(0, 0, 0, 0);

  // Handle reversed selection
  const [rangeStart, rangeEnd] =
    startTime <= endTime ? [startTime, endTime] : [endTime, startTime];

  return dateTime > rangeStart && dateTime < rangeEnd;
};

// Convert value to string or empty string
export const toStringValue = (value: unknown): string => {
  if (value instanceof Date) return formatDate(value);
  if (typeof value === "string") return value;
  return "";
};
